import { Locale, type LocalizedString } from "../Locale.js";
import { NewsCategory } from "../NewsCategory.js";
import { caseStudiesNameMap } from "../names/caseStudiesNameMap.js";

export enum BlogCategory {
	News = "News",
	Guides = "Guides",
	ProductNews = "ProductNews",
	Events = "Events",
	CaseStudy = "CaseStudy",
}

export const newsCategoryToBlogCategoryMap: Record<NewsCategory, BlogCategory> = {
	[NewsCategory.News]: BlogCategory.News,
	[NewsCategory.Guides]: BlogCategory.Guides,
	[NewsCategory.ProductNews]: BlogCategory.ProductNews,
	[NewsCategory.Events]: BlogCategory.Events,
};

export function blogCategoryFromNewsCategory(category: NewsCategory): BlogCategory {
	return newsCategoryToBlogCategoryMap[category];
}

export const blogCategoryOrder: BlogCategory[] = [
	BlogCategory.CaseStudy,
	BlogCategory.News,
	BlogCategory.Guides,
	BlogCategory.ProductNews,
	BlogCategory.Events,
];

export const blogCategoryNameMap: Record<BlogCategory, LocalizedString> = {
	[BlogCategory.News]: {
		[Locale.cs]: "Aktuality",
		[Locale.en]: "News",
	},
	[BlogCategory.Guides]: {
		[Locale.cs]: "Návody & tipy",
		[Locale.en]: "How-to & tips",
	},
	[BlogCategory.ProductNews]: {
		[Locale.cs]: "Produktové novinky",
		[Locale.en]: "Product news",
	},
	[BlogCategory.Events]: {
		[Locale.cs]: "Akce & veletrhy",
		[Locale.en]: "Events & trade fairs",
	},
	[BlogCategory.CaseStudy]: caseStudiesNameMap,
};

export const blogCategoryAnchorMap: Record<BlogCategory, LocalizedString> = {
	[BlogCategory.News]: {
		[Locale.cs]: "aktuality",
		[Locale.en]: "news",
	},
	[BlogCategory.Guides]: {
		[Locale.cs]: "navody-a-tipy",
		[Locale.en]: "how-to-and-tips",
	},
	[BlogCategory.ProductNews]: {
		[Locale.cs]: "produktove-novinky",
		[Locale.en]: "product-news",
	},
	[BlogCategory.Events]: {
		[Locale.cs]: "akce-a-veletrhy",
		[Locale.en]: "events-and-trade-fairs",
	},
	[BlogCategory.CaseStudy]: {
		[Locale.cs]: "pripadove-studie",
		[Locale.en]: "case-studies",
	},
};
